import { Box, Center, Flex, Link, Text } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import home from "~/images/home.jpg";
import { Logo } from "~/images/svgs";
import { RoadSvg } from "../RoadSvg";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";
import { useNavbarHeight } from "~/lib/hooks";

export const FirstPanel = () => {
  const navbarHeight = useNavbarHeight();
  return (
    <Flex
      minH={`calc(100svh - 60px)`}
      flexDirection="column"
      alignContent="flex-end"
      justifyContent="flex-end"
      backgroundImage={`url(${home.src})`}
      backgroundSize={"cover"}
      backgroundPosition="center"
      position="relative"
      padding={{ base: "64px 32px", md: "104px", lg: "32px 104px" }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 6 }}
      >
        <Flex
          position="relative"
          flexDir="column"
          justifyContent={{ base: "flex-end", md: "space-between" }}
          pt={navbarHeight}
        >
          <Box position="absolute" bottom="0" left="0" w="100%">
            <RoadSvg />
          </Box>

          <Box
            position="relative"
            w={{ base: "320px", md: "420px", lg: "70%" }}
            mb={{ base: 16, lg: 24 }}
          >
            <Logo
              h={{ base: "30px", lg: "50px" }}
              mb={{ base: "24px" }}
              color={{ base: "white", lg: "white" }}
            />
            <Text
              w={{ base: "80vw" }}
              fontSize={{ base: "5xl", lg: "8xl" }}
              fontWeight="thin"
              color="white"
              flexWrap="wrap"
              as="span"
            >
              The winding route to{" "}
            </Text>
            <Text
              fontSize={{ base: "5xl", lg: "8xl" }}
              color="white"
              fontWeight="bold"
              as="span"
            >
              adventure
            </Text>
          </Box>
        </Flex>
      </motion.div>
      <SwiperArrow />
      <Box id="container" />
    </Flex>
  );
};
FirstPanel.displayName = "SwiperSlideFirstPanel";

const SwiperArrow = () => {
  return (
    <Flex
      alignItems="center"
      gap={5}
      position="absolute"
      bottom="0"
      left="50%"
      transform="translateX(-50%) translateY(50%)"
      zIndex={10}
    >
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          transition={{ duration: 6 }}
        >
          <Link href="#container">
            <Center
              backgroundColor={"#F7971E"}
              height={14}
              width={14}
              borderRadius="full"
            >
              <IconChevronDown size={40} stroke={1.5} />
            </Center>
          </Link>
        </motion.div>
      </AnimatePresence>
    </Flex>
  );
};
